// EVENT TYPES
export const FIREBASE = 'firebase';

// GENERICS
export const EVENT_SCREEN_VIEW = 'screen_view';
export const EVENT_CLICK = 'click';
export const EVENT_ERROR = 'app_exception';
export const EVENT_LOG = 'app_exception';
export const EVENT_MESSAGE_VIEW = 'message_view';
